import { z } from 'zod';

export default function getCommentFormSchema() {
  return z.object({
    comment: z.string({ message: 'กรุณากรอกความคิดเห็น' }),
  });
}
